import React, { useState, useEffect } from 'react';

import { ReactComponent as ParcelsDueDate } from '../../../../assets/novosicones/Renegociacao/event_black_24dp.svg';

import DropDown from '../../../Reutilizaveis/DropDown';

import { Item, ItemContent } from './styles.js';
import { findMonthByIndex } from '../../../../Utils/Meses';
import { ReactComponent as HelpIcon } from '../../../../assets/novosicones/help_outline.svg';
import TooltipStandard from '../../../TooltipStandard';

const MesVencimentoPrimeiraParcela = ({ estilo, tema, regras, setRegras }) => {
  const [options, setOptions] = useState([]);
  const [mesVencimentoPrimeiraParcela, setMesVencimentoPrimeiraParcela] =
    useState('');

  function generateMonthsOptions() {
    const date = new Date();

    let actualMonth = date.getMonth();

    let nextMonthIndex = actualMonth + 1;

    let nextMonthPlus1Index = actualMonth + 2;

    // dezembro === 11
    // novembro === 10

    if (actualMonth === 10) {
      nextMonthIndex = 11;
      nextMonthPlus1Index = 0;
    }

    if (actualMonth === 11) {
      nextMonthIndex = 0;
      nextMonthPlus1Index = 1;
    }

    const nextMonthName = findMonthByIndex(nextMonthIndex);

    const nextMonthPlus1Name = findMonthByIndex(nextMonthPlus1Index);

    const optionsArray = [
      { nome: nextMonthName, id: 1 },
      { nome: nextMonthPlus1Name, id: 2 },
    ];
    setOptions(optionsArray);
  }

  function findOptionId(monthName) {
    const option = options.find((option) => option.nome === monthName);
    const optionId = option?.id;

    return optionId;
  }

  function setValueMesVencimentoPrimeiraParcela(nome) {
    setMesVencimentoPrimeiraParcela({
      nome,
      id: findOptionId(nome),
    });
  }

  useEffect(() => {
    setRegras({ ...regras, mesVencimentoPrimeiraParcela });
  }, [mesVencimentoPrimeiraParcela]);

  useEffect(() => {
    generateMonthsOptions();
  }, []);
  return (
    <Item>
      <span className='labelWithIcon'>
        <b>Mês de vencimento da primeira parcela:</b>
        <TooltipStandard
          title={
            'Dentre as opções apresentadas abaixo, escolha em qual mês deseja começar a pagar o parcelamento.'
          }
        >
          <HelpIcon />
        </TooltipStandard>
      </span>
      <ItemContent>
        <ParcelsDueDate
          className='iconeRenegociacao'
          style={
            mesVencimentoPrimeiraParcela
              ? { fill: tema.primaryColor }
              : { fill: '#4d4d4d' }
          }
        />

        <DropDown
          itens={options}
          idDropDown={'MesVencimentoPrimeiraParcela'}
          nomeDropDown='Selecione o melhor mês'
          setValue={setValueMesVencimentoPrimeiraParcela}
          style={{ margin: 0, border: 0 }}
          renegociacao
          renegociacaoWidth={estilo}
        />
      </ItemContent>
    </Item>
  );
};

export default MesVencimentoPrimeiraParcela;
